import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useMatch } from "react-router-dom";
import useAuth from "base/hooks/useAuth";

interface Props {
  children: ReactElement;
}

const AuthGuard = ({ children }: Props) => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const isHome = useMatch("/");
  const [isCheckedLogin, setIsCheckedLogin] = useState(false);

  useEffect(() => {
    console.log("isLoggedIn", isLoggedIn);
    if (!isLoggedIn) {
      navigate("login", { replace: true });
    } else {
      setIsCheckedLogin(true);
    }
  }, [isLoggedIn, isHome]);

  return children;
};

export default AuthGuard;
